import { isMobileOnly } from 'react-device-detect';
export const isSsr = typeof window === 'undefined';
export const getHost = () => {
    if (isSsr)
        return '';
    if (process.env.NODE_ENV === 'production' && !process.env.DOMAIN_NAME) {
        return `https://${window.location.hostname}`;
    }
    return window.location.origin;
};
export const getChannelID = () => (isMobileOnly ? 2 : 1);
export const generateXB3TraceID = () => Math.random().toString(16).substring(2) +
    new Date().getTime().toString(16).substring(0, 15);
